<template>
    <div class="col-12 p-3">
        <div class="row d-block">
            <div class="col-12 col-lg-3">
                <div class="my-3">
                    <SearchComponent v-model="filters.search"/>
                </div>
            </div>
        </div>
        <div class="d-flex align-items-center mb-3">
            <div class="d-flex flex-column flex-md-row input-group-sm my-md-3 w-100 w-md-auto">
                <datetime
                    class="my-1 mr-md-2 h-100"
                    v-model="filters.fecha_compra_desde"
                    @input="debouncedGetPedidos()"
                    placeholder="Fecha desde"
                    input-class="custom-select h-100"
                    type="datetime"
                />
                <datetime
                    class="my-1 mr-md-2 h-100"
                    v-model="filters.fecha_compra_hasta"
                    @input="debouncedGetPedidos()"
                    placeholder="Fecha hasta"
                    input-class="custom-select h-100"
                    type="datetime"
                />
                
                <select class="custom-select w-auto my-1 mr-md-2" id="search" v-model="filters.search_for" @change="debouncedGetPedidos()">
                    <option value="">Buscar por</option>
                    <option value="n_pedido">Nº de pedido</option>
                    <option value="qr_code">Código QR</option>
                    <option value="nombre_usuario">Nombre usuario</option>
                    <option value="telefono_usuario">Teléfono</option>
                    <option value="nif_usuario">NIF</option>
                    <option value="email_usuario">Email</option>
                    <option value="importe">Importe</option>
                    <option value="email_taquillero">Taquillero/a</option>
                    <option value="concepto">Concepto</option>
                    <option value="nombre_producto">Nombre producto</option>
                </select>

                <select class="custom-select w-auto my-1 mr-md-2" v-model="filters.recogido" @change="debouncedGetPedidos()">
                    <option value="">Recogido</option>
                    <option value="recogido">SI</option>
                    <option value="">NO</option>
                </select>
                
                <Button
                    @click="clearFilters"
                    class="d-flex align-items-center
                        justify-content-center 
                        col-12 col-md-auto 
                        my-1 mr-md-2 mr-0 mb-2 mb-md-0 mb-md-2"
                    style="padding: 10px;"
                    icon="fa fa-trash"
                    name="tooltip"
                    v-b-tooltip.hover.bottom
                    title="Limpiar filtros"
                />
            </div>
        </div>
    
        <span>
            <div class="row d-none d-md-flex font-weight-bold">
                <label class="h5 col-2 mr-4">GENERADO</label>
                <label class="h5 col-2 mr-4">MODALIDAD</label>
                <label class="h5 col-2">TAQUILLERO / EMAIL ENVÍO</label>
            </div>
            <hr class="d-none d-md-block mt-2"/>
            <div v-if="!loading">
                <template v-if="pedidos?.data?.length > 0">
                    <div v-for="(pedido, index) in pedidos.data" :key="index">
                        <div class="row mb-2">
                            <div class="col-12 col-md-9">
                                <div class="mb-2">
                                    <div class="row">
                                        <div class="col-7 col-md-3">
                                            <div>
                                                <span type="producto_id"><strong class="mvl">GENERADO</strong> {{ pedido.id }}</span>
                                            </div>
                                            <i class="text-green fas fa-calendar-alt mr-1 pl-0"></i>{{ pedido.fecha_compra }}
                                            <br/>
                                            <template v-if="pedido.products.every(producto => producto.deleted_at)">
                                                <b>ANULADO</b>
                                            </template>
                                        </div>
                                        <div class="col-5 col-md-3 p-0">
                                            <strong class="mvl">MODALIDAD</strong><br/>
                                            <i class="text-green fas fa-credit-card ml-md-3"></i>{{ pedido.metodo_pago | formatear_metodo_pago_entrada }}
                                            <br/>
                                        </div>
                                        <div class="col-12 col-md-4 mvl_mrgn">
                                            <strong class="mvl">TAQUILLERO / EMAIL ENVÍO</strong><br/>
                                            <template v-if="pedido.email_taquillero">
                                                {{ pedido.email_taquillero }} <br/>
                                            </template>
                                            {{ pedido.email_comprador || "NO ENVIADOS" }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-3 text-center align-md-right d-flex justify-content-md-end mt-3">
                                <button id="productos-count" class="btn btn-primary mr-3 mb-3" @click="expandir2(index)">Productos ({{ pedido.products.length }})</button>
                                <div :class="'btn-group dropleft ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                    <button type="button" class="btn btn-primary dropdown-toggle mb-3" @click.prevent="expandir(index)">OPCIONES</button>
                                    <div :class="'dropdown-menu ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                        <a
                                            v-if="!pedido.products.every(producto => producto.deleted_at)"
                                            class="dropdown-item" 
                                            :href="api_base + '/f/partidos/productos/pdf?tid=' + configuracion.hash_teatro + '&qr_code=' + pedido.products[0].qr_code"
                                            target="_blank"
                                        >
                                            Descargar productos
                                        </a>
                                        <template v-else>
                                            <div class="dropdown-item"><b>ANULADO</b></div>
                                        </template>
                                        <button
                                            v-if="!pedido.products.every(product => product.deleted_at)"
                                            class="dropdown-item" 
                                            @click.prevent="showModal('anular-pedido-' + pedido.id)"
                                        >
                                            Anular
                                        </button>
                                        <AnularProductos
                                            :name="'anular-pedido-' + pedido.id"
                                            :pedido="pedido"
                                            :sesion_id="parseInt(sesion_id)"
                                            :evento_id="evento.id"
                                            :evento_pasado="evento.pasado"
                                            title="Anular pedido"
                                            @close="closeModal"
                                            @anulado="getPedidos"
                                        />  
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div :key="'2-' + index" v-if="expand2.indexOf(index) >= 0" :class="expand.indexOf(index) >= 0 ? 'bg-light' : ''">
                            <div v-for="(product, index) in pedido.products" :key="'ticket-' + index" class="row">
                                <div class="col-12 col-md-10">
                                    <div class="row align-items-center justify-content-between">
                                        <div :class="!product.deleted_at ? 'col-12 col-md-4' : 'col-12 col-md-3'">
                                            <p><strong>{{ product.price | formatear_precio }} x{{ product.units }}</strong><br/>
                                                {{ product.nombre_producto }}
                                                {{ product.descripcion_producto }}</p>
                                            <p><strong>{{ product.qr_code }}</strong></p><br/>
                                        </div>
                                        <div :class="!product.deleted_at ? 'col-12 col-md-8 pl-md-5 mt-0 mt-md-3' : 'col-12 col-md-3 mr-md-2 mt-0 mt-md-5 mb-2'">
                                            <span>
                                                <b>Recogido:</b> {{ product.hora_recogida ?? 'NO' }}
                                            </span>
                                        </div>
                                        <div v-if="product.deleted_at" class="col-12 col-md-3 mr-md-2 mt-0 mt-md-5 mb-2">
                                            <span>
                                                <b>ANULADO</b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-2 text-right">
                                    <template v-if="!product.deleted_at">
                                        <a class="btn btn-primary mb-3" href="#" @click.prevent="showModal('anular-producto-' + product.id)">Anular</a>
                                        <AnularProductos
                                            :name="'anular-producto-' + product.id"
                                            :pedido="pedido"
                                            :producto_id="product.id"
                                            :sesion_id="parseInt(sesion_id)"
                                            :evento_id="evento.id"
                                            :evento_pasado="evento.pasado"
                                            title="Anular producto"
                                            @close="closeModal"
                                            @anulado="getPedidos"
                                        />
                                    </template>
                                </div>
                                <hr v-if="index < pedido.products.length - 1" style="width: 99%;"/>
                            </div>
                        </div>
                        <hr v-if="pedidos?.data?.length > 0"/>
                    </div>
                </template>
                <div v-else>
                    <h5 class="p-3">No se han vendido productos en este evento</h5>
                </div>
            </div>
            <div 
                v-else
                class="col-12"
                style="margin-top: 20px; height: 100px;" 
            >
                <LoaderComponent />
            </div>
        </span>
        <div class="row justify-content-between">
            <div class="col-12 col-lg-3">
                <ElementosPorPaginaComponent v-model="filters.per_page"/>
            </div>
            <div class="col-12 col-lg-4">
                <PaginateComponent :current_page="loading ? 1 : pedidos.meta.current_page" :last_page="loading ? 1 : pedidos.meta.last_page" @change_page="setPage"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
    import SearchComponent from "@/components/backend/components/SearchComponent";
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
    import AnularProductos from "./modals/AnularProductos";

    export default {
        props: ['sesion_id', 'evento', 'sesiones'],
        data(){
            return{
                pedidos: null,
                loading: true,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    search_for: "",
                    recogido: "",
                    fecha_compra_hasta: "",
                    fecha_compra_desde: "",
                    nombre_usuario: "",
                    telefono_usuario: "",
                    nif_usuario: "",
                    email_usuario: "",
                    importe: "",
                    email_taquillero: "",
                    concepto: "",
                    nombre_producto: ""
                },
                expand: [],
                expand2: [],
                api_base: process.env.VUE_APP_API_BASE
            }
        },
        created() {
            this.debouncedGetPedidos = _.debounce(this.getPedidos, 500);
        },
        watch: {
            "filters.search"() {
                this.debouncedGetPedidos();
            },
            "filters.fecha_compra"() {
                this.debouncedGetPedidos();
            },
            "filters.per_page"() {
                this.filters.page = 1; this.debouncedGetPedidos();
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            api_key() {
                return localStorage.getItem('token');
            }
        },
        methods: {
            getPedidos() {
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.productos.index'), this.searchParams()).then(res => {
                    this.pedidos = res.data;
                    this.loading = false;
                }).catch(() => {
                    console.error('Error al obtener el listado de productos');
                });
            },
            setPage(page) {
                this.filters.page = page;
                this.getPedidos();
            },
            expandir(index) {
                if(this.expand.indexOf(index) >= 0) {
                    this.expand.splice(this.expand.indexOf(index), 1);
                } else {
                    this.expand = [index];
                }
            },
            expandir2(index) {
                if(this.expand2.indexOf(index) >= 0) {
                    this.expand2.splice(this.expand2.indexOf(index), 1);
                } else {
                    this.expand2 = [index];
                }
            },
            searchParams() {
                const params = {
                    evento_id: this.evento?.id,
                    sesion_id: this.sesion_id,
                    filters : {
                        per_page: this.filters.per_page,
                        page: this.filters.page,
                        recogido: this.filters.recogido,
                        fecha_compra_hasta: this.filters.fecha_compra_hasta,
                        fecha_compra_desde: this.filters.fecha_compra_desde,
                        nombre_usuario: this.filters.nombre_usuario,
                        telefono_usuario: this.filters.telefono_usuario,
                        nif_usuario: this.filters.nif_usuario,
                        email_usuario: this.filters.email_usuario,
                        importe: this.filters.importe,
                        email_taquillero: this.filters.email_taquillero,
                        concepto: this.filters.concepto,
                        nombre_producto: this.filters.nombre_producto
                    }
                };
 
                if(this.filters.search_for !== "") {
                    params.filters[this.filters.search_for] = this.filters.search;
                }

                return params;
            },
            clearFilters() {
                this.filters.search = '';
                this.filters.search_for = '';
                this.filters.recogido = '';
                this.filters.fecha_compra_hasta = '';
                this.filters.fecha_compra_desde = '';
                this.filters.nombre_usuario = '';
                this.filters.telefono_usuario = '';
                this.filters.nif_usuario = '';
                this.filters.email_usuario = '';
                this.filters.importe = '';
                this.filters.email_taquillero = '';
                this.filters.concepto = '';
                this.filters.nombre_producto = '';

                this.getPedidos();
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            showModal(modal) {
                this.$modal.show(modal);
            }
        },
        components: {
            ElementosPorPaginaComponent, SearchComponent, PaginateComponent, AnularProductos
        }
    }
</script>

<style scoped>
.d-lg-flex {
    display: absolute;
    flex-wrap: wrap;
}

.mvl {
    display: none !important;
}

@media (max-width: 768px) {
    .mvl_mrgn {
        margin-top: 12px !important;
    }

    .d-lg-flex {
        flex-direction: row;
        align-items: flex-start;
    }

    .mr-1, .mr-2 {
    margin-right: 0;
    }

    .ml-1 {
    margin-left: 0;
    }

    .mr-1, .mr-2, .ml-1 {
    margin-top: 10px;
    }

    .btn_fltr {
        width: 130px;
        margin-left: 12px !important;
        padding: 12px;
    }

    .dsktp {
        display: none !important;
    }

    .mvl {
        display: contents !important;
    }

    .mr-1 {
        padding-left: 12px;
    }

    .col-2, .col-4 {
        -ms-flex: 0 0 100% !important;
        flex: 0 0 100% !important;
        max-width: 100% !important;
    }

    .btn_rgt {
        margin-right: 0px !important;
    }
}
</style>